import React, { useState } from "react";
import { useSelector } from "react-redux";
import { TextField, Button, Box, Typography, Paper,useTheme,Grid } from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import apiClient from './networking/axiosconfig';
import { tokens } from "./theme";

const LoginPage = ({ callBack }) => {

  const showErrorMessage = (message) => toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    });
  const { data: config, loading, error } = useSelector((state) => state.config);

  const [credentials, setCredentials] = useState({ username: "", password: "", appVersion:"1.3" });
  const [errors, setErrors] = useState({ username: "", password: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));

    // Clear errors as user types
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!credentials.username) {
      newErrors.username = "Username is required";
    }
    if (!credentials.password) {
      newErrors.password = "Password is required";
    } else if (credentials.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters long";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const postLoginData = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    credentials.email = credentials.username;
    const raw = JSON.stringify(credentials);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(config.API_BASE_URL + "/api/auth/login", requestOptions)
      .then((response) => {
        if (!response.ok) {
          showErrorMessage(`Login failed with status ${response.status}`);
          throw new Error(`Login failed with status ${response.status}`);
        }
        return response.json();
      })
      .then((result) => {
        if (result.token) {
            console.log("Login successful!", result);
            localStorage.setItem('token',result.token);
            localStorage.setItem('username',"admin");
            localStorage.setItem("roleName","Web Admin")
            callBack();
          } else {
          showErrorMessage("Login failed: ", result.message || "Unknown error");
          console.error("Login failed: ", result.message || "Unknown error");
        }
      })
      .catch((error) => {
        //showErrorMessage("An error occurred during login: ", error.message);
        console.error("An error occurred during login: ", error.message);
      });
  };

  const fetchUserMappings = async () => {

    try {
        const query_params = {}
        //query_params.filters = JSON.stringify([["userId","IN",localStorage.getItem("userIds")]]);
        const response = await apiClient.get(`${config.API_BASE_URL}/api/mvu`,{ params: query_params } );
        const fetchedData = response.data.sort((a, b) => b.id - a.id);
        localStorage.setItem("mvuMapping",JSON.stringify(fetchedData));
        fetchDistricts();
    } catch (error) {
        console.error(error);
    }
};
const fetchDistricts = async () => {

  try {
      const query_params = {}
      //query_params.filters = JSON.stringify([["userId","IN",localStorage.getItem("userIds")]]);
      const response = await apiClient.get(`${config.API_BASE_URL}/api/districts`,{ params: query_params } );
      const fetchedData = response.data.sort((a, b) => b.id - a.id);
      localStorage.setItem("districts",JSON.stringify(fetchedData));
      callBack();
  } catch (error) {
      console.error(error);
  }
};


  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      console.log("Login Submitted: ", credentials);
      postLoginData();
    }
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: 'url("/assets/background.jpg")',       // Replace with your image path
        backgroundSize: "cover", // Ensures the image covers the entire box
        backgroundPosition: "center", // Centers the image
        backgroundRepeat: "no-repeat" // Prevents repeating
      }}
    >
<Paper
  elevation={3}
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    maxWidth: 800,
    width: "100%",
    height: { xs: "auto", md: 400 },
    overflow: "hidden"
  }}
>
  {/* Left Column with Background and Logo */}
  <Grid
  item
  xs={12}
  md={6}
  sx={{
    backgroundColor: '#2CB289',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 2,
  }}
>
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    }}
  >
    <Box
      component="img"
      src="/assets/logo.png"
      alt="Logo"
      sx={{
        width: { xs: "60%", md: "100%" },
        maxHeight: { xs: 200, md: "100%" },
        objectFit: "contain",
        mb: 2,
      }}
    />
    <Typography variant="h3" sx={{ color: "white", fontWeight: "600" }}>
      Largest electronics store in AP
    </Typography>
  </Box>
</Grid>

  {/* Right Column with Login Form */}
  <Grid
    item
    xs={12}
    md={6}
    sx={{
      padding: 4,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    }}
  >
    <Typography variant="h4" gutterBottom>
      Login
    </Typography>
    <form onSubmit={handleSubmit}>
      <TextField
        label="Username"
        variant="outlined"
        fullWidth
        margin="normal"
        name="username"
        value={credentials.username}
        onChange={handleChange}
        error={Boolean(errors.username)}
        helperText={errors.username}
      />
      <TextField
        label="Password"
        variant="outlined"
        fullWidth
        type="password"
        margin="normal"
        name="password"
        value={credentials.password}
        onChange={handleChange}
        error={Boolean(errors.password)}
        helperText={errors.password}
      />
      <Button
        type="submit"
        variant="contained"
        fullWidth
        sx={{
          marginTop: 2,
          backgroundColor: '#2CB289',
          "&:hover": { backgroundColor: "#1e88e5" },
        }}
      >
        Login
      </Button>
      <ToastContainer />
    </form>
  </Grid>
</Paper>

    </Box>
  );
};

export default LoginPage;
